'use-client';
import React from 'react';
import type { IStylableButtonImperativeActions } from '../../../../../StylableButton/StylableButton.types';
import type { ISlideshowButtonProps } from '../../../../types';
import { classes, st } from './SlideshowButton.component.st.css';
import StylableButton from '../../../../../StylableButton/viewer/skinComps/Default/Default.skin';
import SlideshowButtonCommon from '../../SlideshowButtonCommon';
import classNames from 'classnames';

const SlideshowButton: React.ForwardRefRenderFunction<
  IStylableButtonImperativeActions,
  ISlideshowButtonProps
> = (props, ref) => {
  const disabled = props.isDisabled || props.isDisabledByCtx;

  return (
    <SlideshowButtonCommon
      {...props}
      ref={ref}
      StylableButtonComponent={StylableButton}
      className={classNames(
        st(classes.root),
        disabled ? st(classes.disabled) : '',
      )}
    />
  );
};

export default React.forwardRef(SlideshowButton);
